import { _ as _assert_this_initialized } from "@swc/helpers/_/_assert_this_initialized";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _get } from "@swc/helpers/_/_get";
import { _ as _get_prototype_of } from "@swc/helpers/_/_get_prototype_of";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _create_super } from "@swc/helpers/_/_create_super";
import { ContinousBaseGesture } from "./gesture";
export var HoverEffect;
(function(HoverEffect) {
    HoverEffect[HoverEffect["NONE"] = 0] = "NONE";
    HoverEffect[HoverEffect["LIFT"] = 1] = "LIFT";
    HoverEffect[HoverEffect["HIGHLIGHT"] = 2] = "HIGHLIGHT";
})(HoverEffect || (HoverEffect = {}));
export var hoverGestureHandlerProps = [
    "hoverEffect"
];
function changeEventCalculator(current, previous) {
    "worklet";
    var changePayload;
    if (previous === undefined) {
        changePayload = {
            changeX: current.x,
            changeY: current.y
        };
    } else {
        changePayload = {
            changeX: current.x - previous.x,
            changeY: current.y - previous.y
        };
    }
    return _object_spread({}, current, changePayload);
}
export var HoverGesture = /*#__PURE__*/ function(ContinousBaseGesture) {
    "use strict";
    _inherits(HoverGesture, ContinousBaseGesture);
    var _super = _create_super(HoverGesture);
    function HoverGesture() {
        _class_call_check(this, HoverGesture);
        var _this;
        _this = _super.call(this);
        _define_property(_assert_this_initialized(_this), "config", {});
        _this.handlerName = "HoverGestureHandler";
        return _this;
    }
    _create_class(HoverGesture, [
        {
            /**
   * Sets the visual hover effect.
   * iOS only
   */ key: "effect",
            value: function effect(effect) {
                this.config.hoverEffect = effect;
                return this;
            }
        },
        {
            key: "onChange",
            value: function onChange(callback) {
                // @ts-ignore TS being overprotective, HoverGestureHandlerEventPayload is Record
                this.handlers.changeEventCalculator = changeEventCalculator;
                return _get(_get_prototype_of(HoverGesture.prototype), "onChange", this).call(this, callback);
            }
        }
    ]);
    return HoverGesture;
}(ContinousBaseGesture);
